<template>
	<v-sheet elevation="0">
		<v-card-title>页面编辑</v-card-title>
		<v-card-text>
			<!-- <v-row>
					<v-col cols="12" class="d-flex align-center">
						分类：
						<category-selector class="d-inline" v-model="form.category_id" @selected="onCategorySelected" />
					</v-col>
				</v-row> -->
			<div class="d-flex flex-row flex-wrap">
				<v-text-field
					label="标题"
					v-model="form.title"
					:error-messages="errors.title"
					hint=""
					persistent-hint
					style="min-width: 25rem"
					class="mr-2"
				></v-text-field>
				<v-text-field
					label="编码"
					v-model="form.code"
					:error-messages="errors.code"
					hint="用于URL中,如 /page/[code] 可以直接访问。最好不要随意修改。"
					persistent-hint
					style="max-width: 10rem"
					class="mr-2"
				></v-text-field>
				<v-text-field
					label="副标题"
					v-model="form.subtitle"
					:error-messages="errors.subtitle"
					hint=""
					persistent-hint
					style="min-width: 30rem"
					class="mr-2"
				></v-text-field>
			</div>
			<div class="d-flex flex-row flex-wrap">
				<v-text-field
					label="作者"
					v-model="form.author"
					:error-messages="errors.author"
					hint=""
					persistent-hint
					style="max-width: 10rem"
					class="mr-2"
				></v-text-field>
				<date-picker v-model="form.publishTime" label="发布日期" :error-messages="errors.publishTime" />
				<v-checkbox v-model="form.isPublic" true-value="y" false-value="n" label="是否发布到通讯"></v-checkbox>
			</div>
			<div class="d-flex flex-row flex-wrap">
				<v-radio-group v-model="form.status" label="状态" inline :error-messages="errors.status">
					<v-radio v-for="(l, k) in refs['PageStatus']" :value="l.value" :label="l.title" :key="k"></v-radio>
				</v-radio-group>
			</div>
			<div class="d-flex flex-row flex-wrap">
				<v-radio-group v-model="form.type" label="类型" inline :error-messages="errors.type">
					<v-radio v-for="(l, k) in refs['PageType']" :value="l.value" :label="l.title" :key="k"></v-radio>
				</v-radio-group>
			</div>
			<div class="d-flex flex-row flex-wrap align-center">
				封面：
				<uploader style="display: inline-block !important" @uploaded="onImgUploaded" accept="image/*" />
				<v-text-field label="填写图片链接" v-model="form.cover"></v-text-field>
				<v-img
					v-if="form.cover"
					style="max-width: 300px; max-height: 100px"
					:src="form.cover"
					aspect-ratio="1"
					contain
				></v-img>
			</div>
			<div class="d-flex flex-row flex-wrap">
				<v-text-field
					label="标签"
					v-model="form.tags"
					:error-messages="errors.tags"
					hint="半角逗号(,)分隔"
					persistent-hint
				></v-text-field>
				<v-text-field
					label="描述"
					v-model="form.description"
					:error-messages="errors.description"
					hint="前端跳转(URL）/后端替换（对应页面的编码）类型的内容，填写到这里"
					persistent-hint
				></v-text-field>
			</div>
			<div class="d-flex flex-row flex-wrap">
				摘要（TLDR）显示在正文最上面
				<rich-editor v-model="form.summary" :min-height="50"></rich-editor>
			</div>

			<div class="d-flex flex-row flex-wrap">
				内容
				<rich-editor v-model="form.content" :min-height="200"></rich-editor>
			</div>
		</v-card-text>

		<v-card-actions>
			<slot name="actions" v-bind="{ object: form }"></slot>
		</v-card-actions>
	</v-sheet>
</template>
<script>
import CategorySelector from '../category/Selector.vue'
import DatePicker from '../common/DatePicker.vue'
import Uploader from '../common/Uploader.vue'
import RichEditor from '../tools/RichEditor.vue'
import { clone } from 'lodash-es'

export default {
	components: { RichEditor, Uploader, CategorySelector, DatePicker },
	props: {
		value: {
			type: Object,
			default: () => {
				return {
					type: 'page',
					status: 'valid'
				}
			}
		},
		errors: {
			type: Object,
			default: () => {
				return {}
			}
		}
	},
	data: () => ({
		form: {},
		refs: {}
	}),
	watch: {
		value: {
			handler: function (nv, oldVal) {
				if (nv) {
					this.form = clone(nv)
				}
			},
			deep: true
		}
	},
	mounted() {
		this.form = clone(this.value)
		this.$api.common.meta('page', 'PageStatus,PageType', (r) => {
			this.refs = r
		})
	},
	methods: {
		onEditorChanged(html) {
			this.form.html = html
		},
		onCategorySelected(ids) {
			this.form.category_id = ids[0]
		},
		onImgUploaded(files) {
			this.form.cover = files[0]
		}
	}
}
</script>
